document.addEventListener('DOMContentLoaded', function() {
  const atcBar = document.getElementById('sticky-atc-bar');
  const atcButton = document.querySelector('button[name="add"]');

  if (atcButton) {
    window.addEventListener('scroll', function() {
      const rect = atcButton.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) {
        atcBar.style.display = 'block';
      } else {
        atcBar.style.display = 'none';
      }
    });

    // Add to Cart button
    document.getElementById('sticky-atc-button').addEventListener('click', function() {
      atcButton.click();
    });

    // Buy Now button
    document.getElementById('sticky-buy-now-button').addEventListener('click', function() {
      const buyNowButton = document.querySelector('button[name="checkout"]');
      if (buyNowButton) {
        buyNowButton.click();
      } else {
        atcButton.click();
        window.location.href = '/checkout';
      }
    });
  }
});
